const STORAGE_KEY = "recentRoutes";
const MAX_RECENT = 3;

// Una pagina visitata di recente: `label` è una chiave i18n, `title` un testo già pronto (es. il nome di un impianto)
export interface RouteRecente {
  path: string;
  label?: string;
  title?: string;
  icon?: string;
}

// Ultime pagine visitate (al massimo 3), salvate nel localStorage del progetto e mostrate come pillole nella sidebar.
export const useRecentRoutes = () => {
  const { $localStorage } = useNuxtApp();

  // Scarta le voci vecchie salvate col path grezzo al posto della label (senza titolo non sono mostrabili)
  const load = (): RouteRecente[] => {
    try {
      const salvate = JSON.parse($localStorage.getItem(STORAGE_KEY) || "[]") as RouteRecente[];
      return salvate.filter((r) => r.title || (r.label && !r.label.startsWith("/")));
    } catch {
      return [];
    }
  };

  const recentRoutes = ref<RouteRecente[]>(load());

  const addRoute = ({ path, label, title, icon }: RouteRecente): void => {
    if (path === "/" || AUTH_PAGES.includes(path)) return;
    const precedenti = load();
    const precedente = precedenti.find((r) => r.path === path);
    const routes = precedenti.filter((r) => r.path !== path);
    routes.unshift({ path, label, title: title || precedente?.title, icon });
    if (routes.length > MAX_RECENT) routes.length = MAX_RECENT;
    $localStorage.setItem(STORAGE_KEY, JSON.stringify(routes));
    recentRoutes.value = routes;
  };

  return { recentRoutes, addRoute };
};
